export default __webpack_public_path__ + "static/media/icon-styledComponets.b5103de8.png";